/**
 * @file Pagination
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Pagination component
 */
const vPagination = () => {
	const filter = document.querySelector( '.v-filter' );

	if ( ! filter ) {
		return;
	}

	const body = document.querySelector( 'body' );
	gsap.registerPlugin( ScrollToPlugin );

	body.addEventListener( 'click', ( e ) => {
		if ( e.target.classList.contains( 'facetwp-page' ) ) {
			gsap.to( window, { duration: 1, scrollTo: filter } );
		}
	} );
};

export default vPagination;
